/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDataleakEvent } from './CRSFDataleakEvent';
import {
    CRSFDataleakEventFromJSON,
    CRSFDataleakEventFromJSONTyped,
    CRSFDataleakEventToJSON,
} from './CRSFDataleakEvent';

/**
 * 
 * @export
 * @interface CRSFDLAggregateSumResult
 */
export interface CRSFDLAggregateSumResult {
    /**
     * 
     * @type {Array<CRSFDataleakEvent>}
     * @memberof CRSFDLAggregateSumResult
     */
    events?: Array<CRSFDataleakEvent>;
    /**
     * 
     * @type {Array<CRSFDataleakEvent>}
     * @memberof CRSFDLAggregateSumResult
     */
    features?: Array<CRSFDataleakEvent>;
    /**
     * 
     * @type {Array<CRSFDataleakEvent>}
     * @memberof CRSFDLAggregateSumResult
     */
    main_leaks?: Array<CRSFDataleakEvent>;
}

/**
 * Check if a given object implements the CRSFDLAggregateSumResult interface.
 */
export function instanceOfCRSFDLAggregateSumResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFDLAggregateSumResultFromJSON(json: any): CRSFDLAggregateSumResult {
    return CRSFDLAggregateSumResultFromJSONTyped(json, false);
}

export function CRSFDLAggregateSumResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDLAggregateSumResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(CRSFDataleakEventFromJSON)),
        'features': !exists(json, 'features') ? undefined : ((json['features'] as Array<any>).map(CRSFDataleakEventFromJSON)),
        'main_leaks': !exists(json, 'main_leaks') ? undefined : ((json['main_leaks'] as Array<any>).map(CRSFDataleakEventFromJSON)),
    };
}

export function CRSFDLAggregateSumResultToJSON(value?: CRSFDLAggregateSumResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(CRSFDataleakEventToJSON)),
        'features': value.features === undefined ? undefined : ((value.features as Array<any>).map(CRSFDataleakEventToJSON)),
        'main_leaks': value.main_leaks === undefined ? undefined : ((value.main_leaks as Array<any>).map(CRSFDataleakEventToJSON)),
    };
}

